module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"hackrob-mlh-convo","short_name":"convo","start_url":"/","icon":"src/images/convo_bubble.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"7dff9840ca7b294b11953864ca6ea590"},
    }]
